import { iPartProps, Part } from '@/Engine/Part';
import { $ } from '@/Engine/state';
import { Object3D } from 'three';
import { v3dMesh } from '@/Interfaces/common';

export class Drawer extends Part {
    //сквозной id  показывает номер ящика группированных по drawerPrototypeId c 1 начиная
    globalId: number;
    constructor(props: iPartProps, globalId: number) {
        super(props);
        this.globalId = globalId;
    }

    getPartition() {
        return this._model.children.find(child => child.name.includes('partition'));
    }

    visibleSeparators() {
        const partition = this.getPartition();
        if (!partition) return;
        partition.visible = false;

        const drawerSeparator = $.toolChest?.drawerSeparators
            ?.find((item) => this.prototypeId === item.drawerPrototypeId && this.globalId <= item.count);
        if (!drawerSeparator || drawerSeparator.count === 0) return;
        partition.visible = true;
    }

    changeModel(model?: Object3D|v3dMesh) {
        super.changeModel(model);
        this.visibleSeparators();
    }
}